import { momentaryMessageDuration } from 'ui/config';
import { utagLinkWishList } from 'features/tealium';
import { Reporter } from 'features/dataCapture';
import { isOverflown } from 'utilities/browser';
import { setButtonDisabledState } from 'utilities/dom';

const trackWishListEvents = utagLinkWishList();

function initializeWishListView (firstLoad) {

	const itemCount = Number($('#totalWishlistItem').val());
	const hasProducts = $('#hasProducts').val() === '1';
	const wishlistOptions = document.querySelector('#wishlistOptions');
	const viewerWishListLink = document.querySelector('#viewerWishListLink');
	const wishlistContainers = document.querySelectorAll('.wishlistResultContainer');
	const addAllToCart = document.querySelector('.addAllItemsToCart');
	const regularItemSkus = [];
	let wishlistCount = 0;

	wishlistContainers.forEach((element) => {

		if (element.getAttribute('data-regular-item') === 'true') {

			regularItemSkus.push(element.getAttribute('data-sku'));

		}

	});

	if (viewerWishListLink) {

		viewerWishListLink.addEventListener('click', (e) => {

			trackWishListEvents({
				eventAction: `Click-${e.target.innerText}`
			});

			document.location.href = `/viewer?skus=${regularItemSkus.join(',')}`;

		});

	}

	if (wishlistOptions) {

		wishlistCount = wishlistOptions.dataset.wishListCount;

	}

	$('.disabledOnNoWishlist').prop('disabled', $('#hasWishlist').val() === '0');

	if (!hasProducts) {

		$('.printEmailWrapper').addClass('disabledWishlist');

	}

	if (firstLoad) {

		if (wishlistCount > 0) {

			const editableWishlistHeader = document.getElementById('wishlistHeaderName');
			// add class to header if name is long and overflowing container
			const headerOverflow = () => {

				if (editableWishlistHeader) {

					if (isOverflown(editableWishlistHeader)) {

						editableWishlistHeader.classList.add('overflowing');

					} else {

						editableWishlistHeader.classList.remove('overflowing');

					}

				}

			};

			headerOverflow();
			const buttonLabels = {
				editLinkText: '<img class="editIcon" src="/img/_universal/icon-lp-edit.svg" alt="" />',
				editLinkAriaLabel: 'Edit Wish List Name'
			};
			const clearErrorClasses = () => {

				// clear error classes if they are present
				const errorEl = document.querySelector('.validationContainer.error');
				if (errorEl) {

					errorEl.querySelector('.validationError').innerHTML = '';
					errorEl.classList.remove('error');
					editableWishlistHeader.classList.remove('error');

				}

			};

			if (!lp.wishlist.printMode) {

				// Initialize Wish List title inline-editing

				function getCaretPosition (element) {

					let caretOffset = 0;
					const doc = element.ownerDocument || element.document;
					const win = doc.defaultView || doc.parentWindow;
					let sel;
					if (typeof win.getSelection !== 'undefined') {

						sel = win.getSelection();
						if (sel.rangeCount > 0) {

							const range = win.getSelection().getRangeAt(0);
							const preCaretRange = range.cloneRange();
							preCaretRange.selectNodeContents(element);
							preCaretRange.setEnd(range.endContainer, range.endOffset);
							caretOffset = preCaretRange.toString().length;

						}

					} else if ((sel = doc.selection) && sel.type != 'Control') {

						const textRange = sel.createRange();
						const preCaretTextRange = doc.body.createTextRange();
						preCaretTextRange.moveToElementText(element);
						preCaretTextRange.setEndPoint('EndToEnd', textRange);
						caretOffset = preCaretTextRange.text.length;

					}
					return caretOffset;

				}

				function moveCursorAt (element, pos) {

					if (!element.firstChild) {

						return;

					}

					let sel;

					element.focus();

					pos = Math.min(pos, element.firstChild.length);
					if (window.getSelection) {

						sel = window.getSelection();
						sel.collapse(element.firstChild, pos);

					} else if (document.selection) {

						sel = document.selection.createRange();
						sel.moveStart('character', pos);
						sel.select();

					}

				}

				function getHighlightedText () {

					let text = '';
					if (window.getSelection) {

						text = window.getSelection().toString();

					} else if (document.selection && document.selection.type != 'Control') {

						text = document.selection.createRange().text;

					}
					return text;

				}

				function replaceHighlightedText (replacementText) {

					let sel;
					let range;
					if (window.getSelection) {

						sel = window.getSelection();
						if (sel.rangeCount) {

							range = sel.getRangeAt(0);
							range.deleteContents();
							range.insertNode(document.createTextNode(replacementText));

						}

					} else if (document.selection && document.selection.createRange) {

						range = document.selection.createRange();
						range.text = replacementText;

					}

				}

				editableWishlistHeader.addEventListener('paste', async (event) => {

					let pastedText;
					const { clipboardData } = event.originalEvent || event;
					if (clipboardData && clipboardData.getData) {

						pastedText = clipboardData.getData('text/plain');

					} else if (window.clipboardData) {

						pastedText = window.clipboardData.getData('Text');

					}
					const pattern = new RegExp(/[*_]/);
					if (pastedText && pattern.test(pastedText)) {

						event.preventDefault();
						event.stopPropagation();
						event.stopImmediatePropagation();
						pastedText = pastedText.replace(/[*_]/g, '');
						const cursorPos = getCaretPosition(editableWishlistHeader);
						const $el = $(editableWishlistHeader);
						const text = $.trim($el.text());
						const pastedTextLength = pastedText.length;
						const totalLength = text.length - getHighlightedText().length + pastedTextLength;
						const diff = totalLength - $el.data('maxlength');

						if (diff > 0) {

							pastedText = pastedText.substr(0, pastedTextLength - diff);

						}
						replaceHighlightedText(pastedText);
						$el.text($el.text()); // to make text as one text node only and simplify moving cursor position
						moveCursorAt(editableWishlistHeader, cursorPos + pastedText.length);
						$el.removeClass('contentEditablePlaceholder');

					}

				});

				window.lp.utils.initContentEditable(
					$('#wishlistHeaderName'),
					{
						suppressStatusMessage: true, // the success/error message will be displayed in another location
						onAjaxSuccessCustom () {

							window.lp.utils.showStatusIndicator('Wish List Saved!');
							headerOverflow();
							trackWishListEvents({
								eventAction: 'Rename-List'
							});

							clearErrorClasses();

						},
						onAjaxErrorCustom (error) {

							window.lp.utils.showStatusIndicator(error);

						},
						onAjaxComplete () {

							setTimeout(window.lp.utils.hideStatusIndicator, momentaryMessageDuration);

						},
						onAfterCancel () {

							clearErrorClasses();

						}
					},
					buttonLabels
				);

			}

		}

	} else {

		// avoid memory leak
		$('.wishlistQty').inputFilter({ type: 'integer' });
		$('.disabledOnEmptyWishlist').prop('disabled', !hasProducts);
		$('.disabledOption').prop('disabled', true);

		if (!hasProducts) {

			$('#wishlistWrapper').addClass('emptyWishlist');
			$('#wishlistHeader .viewType').prop('disabled', true);

			document.querySelectorAll('.btnGetQuote').forEach((b) => setButtonDisabledState(b, true));

		}

		window.lp.utils.getAssetCounts();

		$('#wishlistFooter').attr('data-view', 'gridview');

	}

	if (wishlistCount <= 1) {

		const openWishListLink = document.querySelector('#openWishListLink');
		if (openWishListLink) {

			openWishListLink.remove();

		}

	}

	if (regularItemSkus.length === 0) {

		if (viewerWishListLink) {

			viewerWishListLink.remove();

		}

	}

	if (addAllToCart) {

		if (itemCount < 1) {

			addAllToCart.remove();

		}

	}
	if (itemCount === 0) {

		const sharedWishListLink = document.querySelector('#sharedWishlistLink');
		const printWishListLink = document.querySelector('#printWishlistLink');
		const printHospitalityWishlistLink = document.querySelector('#printHospitalityWishlistLink');
		const createWishListLink = document.querySelector('#createWishListLink');
		const btnGetQuote = document.querySelectorAll('.btnGetQuote');

		if (sharedWishListLink) {

			sharedWishListLink.remove();

		}

		if (printWishListLink) {

			printWishListLink.remove();

		}

		if (createWishListLink) {

			createWishListLink.remove();

		}

		if (printHospitalityWishlistLink) {

			printHospitalityWishlistLink.remove();

		}

		if (btnGetQuote.length) {

			btnGetQuote.forEach((getQuote) => {

				getQuote.classList.add('disabled');
				getQuote.classList.remove('btnGetQuote');

			});

		}

	}

	// Track SkuView events
	if (window.lp.globals.enableDataCapture) {

		const { reporter } = window.lp.dataCapture;
		const wishlistItems = document.querySelectorAll('.wishlistView img[data-sku]');
		wishlistItems.forEach((element) => {

			const isTracked = reporter.isSkuViewRecorded(element);
			if (!isTracked) {

				const data = Reporter.getSkuViewData(element);
				reporter.track(data);

			}

		});
		// Fire SKuView events immediately to bundle the above tracked events in one request
		reporter.send();

	}

	// Show Margin link for CSR
	const $lnkShowMargin = $('.lnkShowMargin');
	const $assetLookupButton = $('.btnAssetLookup');
	$lnkShowMargin.each(function () {

		// move tooltip container to body to avoid absolute-relative positioning issue
		const $tooltip = $(this).closest('div').find('.marginContent').detach();
		$tooltip.appendTo('body');

		$(this).lpTooltip({
			tooltip: $tooltip,
			evtType: 'click',
			arrow: true,
			arrowBorderWidth: 1,
			borderRadius: '2px',
			offsetY: 15,
			arrowSize: 15,
			boxShadow: {
				enabled: true
			}
		});

	});

	$lnkShowMargin.on('click', (e) => {

		const { sku = '', storeNumber = '' } = e.target.dataset;
		trackWishListEvents({ eventAction: 'click-Show-Margin', eventLabel: `${sku}-${storeNumber}` });

	});

	$assetLookupButton.on('click', (e) => {

		const { storeNumber = '' } = e.target.dataset;
		trackWishListEvents({ eventAction: 'click-Asset-Lookup', eventLabel: `${storeNumber}` });

	});

}

export default initializeWishListView;
